type FeatureItem = {
  icon?: React.ReactNode;
  text: string;
};

type FeatureSectionProps = {
  title?: string;
  icon?: React.ReactNode;
  items: FeatureItem[];
};

export function AmenitySection({ icon, title, items }: FeatureSectionProps) {
  return (
    <>
      {items.length ? (
        <section>
          {title || icon ? (
            <div className="mb-4 flex items-center gap-2">
              {icon && <div className="w-7">{icon}</div>}
              <h3 className="font-bold">{title}</h3>
            </div>
          ) : null}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
            {Array.from({ length: Math.ceil(items.length / 2) }, (_, i) => {
              const group = items.slice(i * 2, i * 2 + 2);

              return (
                <div key={i} className="flex flex-col gap-y-4">
                  {group.map((item, index) => (
                    <div key={index} className="flex items-start space-x-2">
                      {item.icon && <div className="w-7">{item.icon}</div>}
                      <span className="text-sm">{item.text}</span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </section>
      ) : null}
    </>
  );
}
